<template>
  <div class="service-user-list-view" :class = "{'clear-header':isWechatBrowser}">
    <my-header title="优选打孔" v-if="!isWechatBrowser" :showBack="true"></my-header>
    <div class="foreman-top">优选打孔</div>
    <div class="service-user-item" v-for="supervisor in supervisorList">
      <img class="service-cover" :src="imgUrl + supervisor.serviceCover" @click="toDetail(supervisor)">
      <div class="service-user-info">
        <div class="top" @click="toDetail(supervisor)">
          <div class="name">{{supervisor.name}}</div>
          <div class="score-part">
            <div class="score">{{supervisor.score | score}}</div>
          </div>
        </div>
        <div class="footer">
          <div class="less-info" @click="toDetail(supervisor)">
            <div class="case-msg">
              <div class="case-info"><img src="../../assets/icon-appointment-num.png"/>预约名额<span class="num">{{supervisor.spares}}</span></div>
              <div class="case-info"><img src="../../assets/icon-case-num.png"/>已服务<span class="num">{{supervisor.serviceCount}}</span></div>
            </div>
            <div class="case-info" v-if="supervisor.deposit"><img src="../../assets/icon-app-deposit.png"/>订金<span class="deposit num">{{supervisor.deposit}}</span></div>
          </div>
          <div v-if="supervisor.spares != 0" class="appoint-btn" @click="reservationSupervisor(supervisor)">
            预 约
          </div>
          <div v-if="supervisor.spares == 0" class="full-btn" @click="reservationSupervisor(supervisor)">
            已 满
          </div>
        </div>
      </div>
    </div>
    <div v-if="supervisorList.length==0" class="black-page">
      <img src="../../assets/icon-no-img.png">
      <div class="tip">暂无相关打孔工人!</div>
    </div>
    <!--预约成功的提示框-->
    <div v-if="alertSuccess" class="toast general-tip-modal">
      <img class="close-btn" src="../../assets/icon-close-btn.png" @click="cancelCall()">
      <div class="general-modal-title">温馨提示</div>
      <div class="general-modal-msg">若已确定预约打孔服务<br/>请拨打服务电话 进行预约沟通<br/><span class="phone">{{servicePhone}}</span></div>
      <div class="agree-btn" @click="callUp()">确认拨打</div>
    </div>
    <div v-if="alertSuccess" class="pay-box"></div>

    <!--温馨提示 -->
    <div v-if="preAppointmentToast" class="toast appointment-reminder">
      <img class="close-btn" src="../../assets/icon-close-btn.png" @click="closeAppointmentReminder">
      <div class="title">温馨提示</div>
      <div class="reminder-content">
        <div>打孔完成服务后</div>
        <div>订金不予退还!</div>
        <div>为您造成的不便敬请谅解!</div>
      </div>
      <div class="agree-btn" @click = "prePayAppointment">确定</div>
    </div>
    <div v-if="preAppointmentToast" class="pay-box"></div>
  </div>
</template>
<script>
  import {imgUrl,shareIcon} from '../../config'
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import SupervisorService from '../../service/SupervisorService'
  import AppointmentService from '../../service/customer/AppointmentService'
  import payUtil from '../../utils/Pay'
  import session from '../../utils/Session'

  export default {
    name: 'PuncherList',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        type:'8',
        supervisorList:[],
        imgUrl: imgUrl,
        isWechatBrowser:this.$verfyBrowserType(),
        servicePhone:'',
        alertSuccess:false,
        preAppointmentToast:false,
        currentSupervisor:{},
        prePayInfo:{},
      }
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.getSupervisorList();
    },
    methods: {
      toDetail(supervisor){
        this.$router.push({name:'PuncherDetail',query:{supervisorId:supervisor.id,supervisorName:supervisor.name}});
      },
      async getSupervisorList(){
        let { code, data} = await SupervisorService.getSupervisorList(this.type);
        console.info(data)
        if(code == 0){
          this.supervisorList = [];
          if(this.synthesize != 0){
            this.supervisorList = data;
          } else {
            let closeSwitchDesigners = [];
            let withoutSparesDesigners = [];
            for(let designer of data){
              if(designer.appointmentSwitch != 1){
                closeSwitchDesigners.push(designer);
              }else if(designer.spares == 0){
                withoutSparesDesigners.push(designer);
              }else {
                this.supervisorList.push(designer);
              }
            }
            this.supervisorList = this.supervisorList.concat(closeSwitchDesigners);
            this.supervisorList = this.supervisorList.concat(withoutSparesDesigners);
          }
        }else {
          Toast('获取优选搬家信息失败');
        }
      },
      async reservationSupervisor(supervisor){
        this.currentSupervisor = supervisor;
        if(supervisor.appointmentSwitch != '1'){
          Toast('该打孔工暂时不接受预约!');
        }else if(supervisor.appointmentSwitch == '1' && supervisor.spares == 0){
          Toast('该打孔工预约已满!');
        }else {
          this.servicePhone = supervisor.phone;
          if(supervisor.deposit && supervisor.deposit>0){
            this.preAppointmentToast = true;
          }else {
            var result = await AppointmentService.createAppointment({isDeposited:'0',type:this.type,customerId:session.getAccountToken().id,supervisorId:supervisor.id});
            if(result.code == '0'){
              this.alertSuccess = true;
            }else {
              Toast('预约失败');
            }
          }
        }
      },
      cancelCall(){
        this.alertSuccess = false;
      },
      callUp(){
        this.alertSuccess = false;
        window.location.href = "tel:"+this.servicePhone;
      },
      async prePayAppointment(){
        this.preAppointmentToast = false;
        let prepayResult = await AppointmentService.prePayAppointment({isDeposited:'1',type:this.type,customerId:session.getAccountToken().id,supervisorId:this.currentSupervisor.id},this.currentSupervisor.deposit);
        if(prepayResult.code == '0'){
          this.prePayInfo = payUtil.pay(prepayResult.data.prepayId,prepayResult.data.nonceStr);
          let requestPay = this.requestPay;
          if (typeof WeixinJSBridge == "undefined"){
            if( document.addEventListener ){
              document.addEventListener('WeixinJSBridgeReady', requestPay, false);
            }else if (document.attachEvent){
              document.attachEvent('WeixinJSBridgeReady', requestPay);
              document.attachEvent('onWeixinJSBridgeReady', requestPay);
            }
          }else{
            this.requestPay();
          }
        } else {
          Toast(prepayResult.msg);
        }
      },
      requestPay(){
        let prePayInfo = this.prePayInfo;
        let that = this;
        try {
          WeixinJSBridge.invoke(
            'getBrandWCPayRequest',
            {
              "appId":prePayInfo.appId,     //公众号名称，由商户传入
              "timeStamp":prePayInfo.timeStamp,         //时间戳，自1970年以来的秒数
              "nonceStr":prePayInfo.nonceStr, //随机串
              "package":prePayInfo.package,
              "signType":prePayInfo.signType,         //微信签名方式：
              "paySign":prePayInfo.paySign //微信签名
            },
            function(res){
              if(res.err_msg == "get_brand_wcpay_request:ok" ) {
                that.alertSuccess = true;
              } else if(res.err_msg == "get_brand_wcpay_request:cancel" ){
                console.info("取消支付");
              }else {
                Toast('支付失败!');
                that.errorMsg = JSON.stringify(res)
              }// 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
            },function (e) {
              console.error("支付失败err!"+JSON.stringify(e));
              Toast("支付失败!"+JSON.stringify(e));
            });
        }catch (e){
          console.error("支付失败-----!"+JSON.stringify(e));
          Toast("支付失败!"+JSON.stringify(e));
        }
      },
      closeAppointmentReminder(){
        this.preAppointmentToast = false;
      }
    }
  }
</script>

<style lang="scss">
  @import '../../assets/style/common.scss';
  @import '../../assets/style/service-user-list';
  .foreman-top{
    padding: 0.47rem 0.34rem 0.3rem;
    font-size: 0.34rem;
    color: white;
    font-weight: bold;
    background: #c4a183;
  }
  .general-tip-modal .phone{
    font-size: 0.34rem;
    font-weight: bold;
  }
</style>
